// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#lines-result-list-container table tr.selected td {\n    color: #856404;\n    background-color: #fff3cd;\n    border-color: #ffeeba;\n}\n\n#lines-result-list-container table tbody tr td {\n    cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
